import { useEffect } from "react";
import Header from "@/components/Header";
import PricingSection from "@/components/PricingSection";
import PassesSection from "@/components/PassesSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";

const PricingPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    document.title = "Pricing | Group & Private English Lessons in CAD | MyEnglish Lesson.ca";
    description?.setAttribute("content", "Compare live Group English Practice, 1-on-1 Private Lessons, and student reward options from MyEnglish Lesson.ca in Canadian dollars.");
    return () => { document.title = previousTitle; if (description && previousDescription) description.setAttribute("content", previousDescription); };
  }, []);

  const goToBookings = () => { document.getElementById("booking-section")?.scrollIntoView({ behavior: "smooth", block: "start" }); };
  const openContact = () => { window.location.href = "/#contact"; };

  return <div className="site-shell" id="pricing-page-top"><Header homePrefix="/" onBook={goToBookings} /><main id="main-content"><PricingSection /><PassesSection onClassPass={openContact} /><FAQSection /></main><Footer homePrefix="/" /></div>;
};

export default PricingPage;
